/**
 * Utility functions for deposit-related operations
 */

/**
 * Checks if any item in the provided array has an expiration date that's in the past
 * @param items Array of items with optional expiresAt property
 * @returns boolean indicating if any item is expired
 */
export const isAnyItemExpired = <T extends { expiresAt?: string | null }>(items: T[]): boolean => {
  return items.some((item) => item.expiresAt && new Date(item.expiresAt) < new Date());
};
